<template>
    <div>
        <div class="wrapper">
            <div class="animated fadeIn">
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <b-button variant="primary" @click="$router.push('/admin/news-articles/toevoegen')" class="pull-right">Nieuwsbericht toevoegen</b-button>
                    </b-col>
                </b-row>
                <resource-index header="Nieuws" endpoint="news-articles" show-route="news-articles.view"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ResourceIndex from '../../components/ResourceIndex';

    export default {
        name: 'news-articles',
        components: {ResourceIndex},
        computed: {
            userRole () {
                return this.$store.state.userRole
            }
        },
    }
</script>
